import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/system-control/pc/index.vue";
import mobile from "../../../../form/src/common/components/system-control/mobile/index.vue";
const info = {
    title: "修改时间",
    type: "modifiedTime",
    icon: "h-icon-all-clock-edit-o",
    dataItemType: DataItemType.Date,
    formControllerType: FormControlType.ModifiedTime,
    group: "系统控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
